// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-campaigns {
  margin-top: 6rem;
}

.campaign-details {
  font-size: var(--Font-Font-Size-h5, 1.4375rem);
  margin-right: 1rem;
  font-weight: 700;
}

.backarrow {
  width: 1.875rem;
}

.campaign-details-page {
  padding-left: 4.37rem;
  padding-right: 4.37rem;
}

.campaign-details-page-alignment {
  display: flex;
  flex-direction: column;
}

.campaign-details-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5.525rem;
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 1.38rem;
}

.campaign-overview {
  flex-shrink: 0;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.campaign-icons {
  width: 1.625rem;
  height: 1.625rem;
}

.campaign-overview-header {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 150% */
}

.campaign-overview-value {
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem; /* 150% */
}

.campaign-overview-section {
  display: flex;
  justify-content: left;
}

.campaign-overview-sub-section {
  width: 16rem;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.campaign-details-action-items {
  font-size: 16px;
  font-weight: 600;
}
.campaign-overview-actions {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-p, 1rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1rem; /* 150% */
  gap: 0.4rem;
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.campaign-overview-actions-headers {
  min-width: 50%;
}

.campaign-overview-total-impressions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  gap: 2%;
}

.campaign-overview-common-css {
  font-family: Roboto;
  color: #000;
  font-size: var(--Font-Font-Size-h3, 2.0625rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.campaign-overview-alignment {
  gap: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.campaign-overview-alignment-container {
  height: auto;
  padding-left: 15px !important;
  padding-right: 0px !important;
}

.campaign-overview-links {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  padding: 20pxx;
}

.campaign-overview-links-item {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: var(--Font-Font-Size-p, 1rem);
  font-weight: 400;
  text-decoration: underline;
}

.disable-button {
  cursor: not-allowed !important;
  opacity: 0.8 !important;
  color: #808080;
}
.add-to-cart:not(.disable-button) {
  margin-left: 1.4rem;
  color: #fff !important;
  background: #d2042d !important;
  border: none !important;
}

.divider {
  height: 2rem !important;
  border-inline-start: 1px solid rgb(5 5 5 / 23%) !important;
  margin-inline: 2px !important;
}

.terms-applied {
  display: flex;
  border-radius: 0.3125rem;
  background: var(--Colors-Primary-500, #d2042d);
  color: #fff;
  padding: 0.5rem 0.875rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
}

.campaign-more-actions-div {
  display: flex;
  flex-wrap: nowrap;
}

.campaign-product-availability {
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  gap: 0.5rem;
}

.campaign-price-section {
  display: flex;
  align-items: center;
}

.campaign-billboard-add-section {
  display: flex;
  margin-right: 0.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.overview-row {
  margin-top: 2rem;
  justify-content: flex-end;
}

@media (max-width: 1440px) {
  .campaign-overview-common-css {
    font-size: var(--Font-Font-Size-h3, 1.2rem);
  }
  .campaign-details-page {
    margin-top: 0rem;
    padding-left: 4.37rem;
    padding-right: 2.37rem;
  }

  .campaign-overview-links {
    padding: 1.3125rem 4rem 1.3125rem 2.437rem;
    justify-content: space-between;
    gap: 1rem;
  }

  .campaign-overview-actions {
    font-size: var(--Font-Font-Size-p, 1rem);
    line-height: 15px;
  }

  .campaign-icons {
    width: 1rem;
    height: 1rem;
  }

  .campaign-overview {
    padding: 2rem 1.5rem;
  }
  .campaign-overview-value {
    color: var(--Colors-Text-500, #0a0f0d);
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
  }
}

@media (max-width: 1024px) {
  .campaign-overview-actions-headers {
    font-size: 9px;
    line-height: 15px;
    /* width: 50%; */
  }

  .campaign-icons {
    width: 1.3rem;
    height: 1.3rem;
  }

  .campaign-overview {
    padding: 1rem 2rem 1rem 2rem !important;
  }

  .campaign-overview-common-css {
    font-size: var(--Font-Font-Size-h3, 1.0625rem);
  }

  .campaign-details-page {
    margin-top: 0rem;
    padding-left: 2.37rem;
    padding-right: 2.37rem;
  }

  .campaign-overview-links-item {
    font-size: var(--Font-Font-Size-p, 0.8rem);
    gap: 1rem !important;
  }

  .campaign-overview-links {
    padding: 1.3125rem 2rem 1.3125rem 2.437rem !important;
    gap: 1rem;
  }

  .campaign-details {
    font-size: var(--Font-Font-Size-h5, 1.3rem);
  }
  .campaign-overview-total-impressions {
    flex-direction: column !important;
  }
  .campaign-overview-total-impressions {
    text-align: center !important;
  }
}

@media (max-width: 768px) {
  .campaign-product-image {
    width: 228px !important;
    height: 140px !important;
  }
  .campaign-details-page {
    padding-top: 0rem;
    margin-top: 0rem;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .campaign-more-actions-container {
    padding-left: 0px !important;
    padding-right: 12px !important;
    /* width: 33%; */
  }

  .campaign-details {
    font-size: var(--Font-Font-Size-h6, 1.1875rem);
    margin-right: 1rem;
    font-weight: 700;
    margin-left: 1rem;
  }
  .margin-class {
    margin-left: 0px !important;
  }

  .campaign-icons {
    width: 1.5rem;
    height: 1.5rem;
  }

  .campaign-details-page {
    margin-top: 0rem;
    padding-left: 1.12rem;
    padding-right: 1.12rem;
  }

  .campaign-more-actions {
    text-align: center;
    width: 100%;
    height: 5rem;
    display: inline-flex;
    padding: 1.0625rem 1.25rem 0.8125rem 1.1875rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    border-radius: 0.625rem;
    background: #fff;
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  }

  .campaign-bill-boards-tabs {
    height: 3.5rem !important;
  }

  .campaign-overview-common-css {
    font-size: var(--Font-Font-Size-h6, 14px) !important;
  }

  .campaign-edit-icon {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .campaigns-buttons {
    display: flex;
    align-items: center;
    padding: 0.5rem 1.25rem;
    font-size: 14px;
    border-radius: 0.3125rem;
    background: #f0f0f0;
  }

  .campaign-overview {
    padding: 1rem 1.5rem 1rem 1.5rem !important;
  }

  .backarrow {
    width: 1.125rem;
  }

  .campaign-details-page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 4.375rem;
    border-bottom: none;
    margin-bottom: 0;
  }

  .add-to-cart {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-left: 1.4rem;
    height: 3.125rem;
    background-color: #d2042d !important;
    color: white !important;
    border: none !important;
    border-radius: 0.3125rem;
    padding: 0.5rem 1.25rem;
  }

  .campaign-more-actions-div {
    height: 32% !important;
    margin-left: 0px !important;
  }

  .campaign-overview-sub-section {
    width: 16rem;
  }

  .campaign-overview-total-impressions {
    margin-bottom: 1.25rem;
    height: 5rem;
  }

  .campaign-details-page-display {
    height: 5rem !important;
  }

  .product-last-section-detail-miles {
    padding-top: 15px !important;
  }
}

@media (max-width: 430px) {
  .campaign-product-image {
    width: 120px !important;
    height: 104px !important;
  }
  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
    display: inline-block;
  }
  .campaign-product-availability {
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    gap: 0.5rem;
  }
  .campaign-details-page {
    margin-top: 0rem;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .campaign-product-availability {
    font-size: 13px;
  }
  .campaign-more-actions-container {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .campaign-more-actions-container {
    padding-left: 0px !important;
  }

  .campaign-more-actions-div {
    margin-left: 0px !important;
  }

  .campaign-more-actions-text {
    font-size: 12px;
  }
  .campaigns-buttons {
    font-size: 12px !important;
  }
  .add-to-cart {
    font-size: 16px !important;
  }
}

@media (max-width: 320px) {
  .campaign-more-actions-container {
    padding-left: 0px !important;
  }
  .campaign-more-actions-div {
    margin-left: 0px !important;
  }

  .campaign-details-page {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .campaign-more-actions-text {
    font-size: 10px;
  }
  .add-to-cart {
    font-size: 10px !important;
  }

  .campaign-more-actions {
    width: 4rem;
    font-size: 12px;
  }

  .campaign-overview-header {
    font-size: 0.7rem !important;
  }

  .campaign-overview-common-css {
    font-size: var(--Font-Font-Size-h6, 1rem) !important;
  }

  .campaign-icons {
    width: 1.5rem;
    height: 1.5rem;
  }

  .my-billboards-tab-headers {
    font-size: 0.5rem;
  }
  .campaign-overview {
    padding: 1rem;
  }
  .campaigns-buttons {
    padding: 0.5rem 1rem;
    font-size: 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/campaigndetailspage/CampaignDetailsPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0DAA0D;EAC1D,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,8CAA8C;EAC9C,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,0CAA0C;IAC1C,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,0CAA0C;IAC1C,oBAAoB;EACtB;;EAEA;IACE,qDAAqD;IACrD,SAAS;EACX;;EAEA;IACE,2CAA2C;EAC7C;EACA;IACE,iCAAiC;EACnC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,8CAA8C;IAC9C,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gDAAgD;EAClD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;AACF","sourcesContent":[".my-campaigns {\n  margin-top: 6rem;\n}\n\n.campaign-details {\n  font-size: var(--Font-Font-Size-h5, 1.4375rem);\n  margin-right: 1rem;\n  font-weight: 700;\n}\n\n.backarrow {\n  width: 1.875rem;\n}\n\n.campaign-details-page {\n  padding-left: 4.37rem;\n  padding-right: 4.37rem;\n}\n\n.campaign-details-page-alignment {\n  display: flex;\n  flex-direction: column;\n}\n\n.campaign-details-page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 5.525rem;\n  border-bottom: 1px solid #d2d2d2;\n  margin-bottom: 1.38rem;\n}\n\n.campaign-overview {\n  flex-shrink: 0;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  padding: 20px;\n}\n\n.campaign-icons {\n  width: 1.625rem;\n  height: 1.625rem;\n}\n\n.campaign-overview-header {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem; /* 150% */\n}\n\n.campaign-overview-value {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem; /* 150% */\n}\n\n.campaign-overview-section {\n  display: flex;\n  justify-content: left;\n}\n\n.campaign-overview-sub-section {\n  width: 16rem;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.campaign-details-action-items {\n  font-size: 16px;\n  font-weight: 600;\n}\n.campaign-overview-actions {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-p, 1rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1rem; /* 150% */\n  gap: 0.4rem;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n}\n\n.campaign-overview-actions-headers {\n  min-width: 50%;\n}\n\n.campaign-overview-total-impressions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  gap: 2%;\n}\n\n.campaign-overview-common-css {\n  font-family: Roboto;\n  color: #000;\n  font-size: var(--Font-Font-Size-h3, 2.0625rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.campaign-overview-alignment {\n  gap: 1rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.campaign-overview-alignment-container {\n  height: auto;\n  padding-left: 15px !important;\n  padding-right: 0px !important;\n}\n\n.campaign-overview-links {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  padding: 20pxx;\n}\n\n.campaign-overview-links-item {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: var(--Font-Font-Size-p, 1rem);\n  font-weight: 400;\n  text-decoration: underline;\n}\n\n.disable-button {\n  cursor: not-allowed !important;\n  opacity: 0.8 !important;\n  color: #808080;\n}\n.add-to-cart:not(.disable-button) {\n  margin-left: 1.4rem;\n  color: #fff !important;\n  background: #d2042d !important;\n  border: none !important;\n}\n\n.divider {\n  height: 2rem !important;\n  border-inline-start: 1px solid rgb(5 5 5 / 23%) !important;\n  margin-inline: 2px !important;\n}\n\n.terms-applied {\n  display: flex;\n  border-radius: 0.3125rem;\n  background: var(--Colors-Primary-500, #d2042d);\n  color: #fff;\n  padding: 0.5rem 0.875rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.campaign-more-actions-div {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.campaign-product-availability {\n  display: flex;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  gap: 0.5rem;\n}\n\n.campaign-price-section {\n  display: flex;\n  align-items: center;\n}\n\n.campaign-billboard-add-section {\n  display: flex;\n  margin-right: 0.5rem;\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\n.overview-row {\n  margin-top: 2rem;\n  justify-content: flex-end;\n}\n\n@media (max-width: 1440px) {\n  .campaign-overview-common-css {\n    font-size: var(--Font-Font-Size-h3, 1.2rem);\n  }\n  .campaign-details-page {\n    margin-top: 0rem;\n    padding-left: 4.37rem;\n    padding-right: 2.37rem;\n  }\n\n  .campaign-overview-links {\n    padding: 1.3125rem 4rem 1.3125rem 2.437rem;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n\n  .campaign-overview-actions {\n    font-size: var(--Font-Font-Size-p, 1rem);\n    line-height: 15px;\n  }\n\n  .campaign-icons {\n    width: 1rem;\n    height: 1rem;\n  }\n\n  .campaign-overview {\n    padding: 2rem 1.5rem;\n  }\n  .campaign-overview-value {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 1.5rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .campaign-overview-actions-headers {\n    font-size: 9px;\n    line-height: 15px;\n    /* width: 50%; */\n  }\n\n  .campaign-icons {\n    width: 1.3rem;\n    height: 1.3rem;\n  }\n\n  .campaign-overview {\n    padding: 1rem 2rem 1rem 2rem !important;\n  }\n\n  .campaign-overview-common-css {\n    font-size: var(--Font-Font-Size-h3, 1.0625rem);\n  }\n\n  .campaign-details-page {\n    margin-top: 0rem;\n    padding-left: 2.37rem;\n    padding-right: 2.37rem;\n  }\n\n  .campaign-overview-links-item {\n    font-size: var(--Font-Font-Size-p, 0.8rem);\n    gap: 1rem !important;\n  }\n\n  .campaign-overview-links {\n    padding: 1.3125rem 2rem 1.3125rem 2.437rem !important;\n    gap: 1rem;\n  }\n\n  .campaign-details {\n    font-size: var(--Font-Font-Size-h5, 1.3rem);\n  }\n  .campaign-overview-total-impressions {\n    flex-direction: column !important;\n  }\n  .campaign-overview-total-impressions {\n    text-align: center !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .campaign-product-image {\n    width: 228px !important;\n    height: 140px !important;\n  }\n  .campaign-details-page {\n    padding-top: 0rem;\n    margin-top: 0rem;\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n  .campaign-more-actions-container {\n    padding-left: 0px !important;\n    padding-right: 12px !important;\n    /* width: 33%; */\n  }\n\n  .campaign-details {\n    font-size: var(--Font-Font-Size-h6, 1.1875rem);\n    margin-right: 1rem;\n    font-weight: 700;\n    margin-left: 1rem;\n  }\n  .margin-class {\n    margin-left: 0px !important;\n  }\n\n  .campaign-icons {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n\n  .campaign-details-page {\n    margin-top: 0rem;\n    padding-left: 1.12rem;\n    padding-right: 1.12rem;\n  }\n\n  .campaign-more-actions {\n    text-align: center;\n    width: 100%;\n    height: 5rem;\n    display: inline-flex;\n    padding: 1.0625rem 1.25rem 0.8125rem 1.1875rem;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 0.75rem;\n    border-radius: 0.625rem;\n    background: #fff;\n    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  }\n\n  .campaign-bill-boards-tabs {\n    height: 3.5rem !important;\n  }\n\n  .campaign-overview-common-css {\n    font-size: var(--Font-Font-Size-h6, 14px) !important;\n  }\n\n  .campaign-edit-icon {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .campaigns-buttons {\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 1.25rem;\n    font-size: 14px;\n    border-radius: 0.3125rem;\n    background: #f0f0f0;\n  }\n\n  .campaign-overview {\n    padding: 1rem 1.5rem 1rem 1.5rem !important;\n  }\n\n  .backarrow {\n    width: 1.125rem;\n  }\n\n  .campaign-details-page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 4.375rem;\n    border-bottom: none;\n    margin-bottom: 0;\n  }\n\n  .add-to-cart {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    margin-left: 1.4rem;\n    height: 3.125rem;\n    background-color: #d2042d !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 0.3125rem;\n    padding: 0.5rem 1.25rem;\n  }\n\n  .campaign-more-actions-div {\n    height: 32% !important;\n    margin-left: 0px !important;\n  }\n\n  .campaign-overview-sub-section {\n    width: 16rem;\n  }\n\n  .campaign-overview-total-impressions {\n    margin-bottom: 1.25rem;\n    height: 5rem;\n  }\n\n  .campaign-details-page-display {\n    height: 5rem !important;\n  }\n\n  .product-last-section-detail-miles {\n    padding-top: 15px !important;\n  }\n}\n\n@media (max-width: 430px) {\n  .campaign-product-image {\n    width: 120px !important;\n    height: 104px !important;\n  }\n  .truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 80%;\n    display: inline-block;\n  }\n  .campaign-product-availability {\n    display: flex;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    gap: 0.5rem;\n  }\n  .campaign-details-page {\n    margin-top: 0rem;\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n  .campaign-product-availability {\n    font-size: 13px;\n  }\n  .campaign-more-actions-container {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n  .campaign-more-actions-container {\n    padding-left: 0px !important;\n  }\n\n  .campaign-more-actions-div {\n    margin-left: 0px !important;\n  }\n\n  .campaign-more-actions-text {\n    font-size: 12px;\n  }\n  .campaigns-buttons {\n    font-size: 12px !important;\n  }\n  .add-to-cart {\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 320px) {\n  .campaign-more-actions-container {\n    padding-left: 0px !important;\n  }\n  .campaign-more-actions-div {\n    margin-left: 0px !important;\n  }\n\n  .campaign-details-page {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n\n  .campaign-more-actions-text {\n    font-size: 10px;\n  }\n  .add-to-cart {\n    font-size: 10px !important;\n  }\n\n  .campaign-more-actions {\n    width: 4rem;\n    font-size: 12px;\n  }\n\n  .campaign-overview-header {\n    font-size: 0.7rem !important;\n  }\n\n  .campaign-overview-common-css {\n    font-size: var(--Font-Font-Size-h6, 1rem) !important;\n  }\n\n  .campaign-icons {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n\n  .my-billboards-tab-headers {\n    font-size: 0.5rem;\n  }\n  .campaign-overview {\n    padding: 1rem;\n  }\n  .campaigns-buttons {\n    padding: 0.5rem 1rem;\n    font-size: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
